import styles from './styles.module.scss';
import Color from 'color';
import { ErrorCard } from '@starsoft/common/components';
import BonusClaimModalContentHeader from './Header';
import { getBonusTypeColor } from '../../../Card/helper';
import { useUserBonusByIdWithParams } from '@/hooks/user-bonus/useUserBonusByIdWithParams';
import UserBonusCardCheckpointsRenderer from '../../../Card/Checkpoints/Renderer';
import useTranslation from 'next-translate/useTranslation';
import UserBonusModalContentGames from './Games';
import { activeUserBonusStatus } from '@/constants/user-bonus';
import UserBonusModalCoinTable from './CoinTable';
import { useMemo } from 'react';
import SportsCard from './SportsCard';
import { BonusStatusId } from '@/enums/bonusStatusId';
import { BonusTypeType } from '@/enums/bonusTypeId';

export default function ClaimBonus() {
  const { t } = useTranslation('bonus');
  const { error, refetch, userBonus, isLoading, curretCheckpointIndex } =
    useUserBonusByIdWithParams({ refetchOnMount: 'always' });

  const isActiveBonus: boolean =
    activeUserBonusStatus?.includes(userBonus?.status?.id?.toString()) ||
    userBonus?.status?.id?.toString() == BonusStatusId.Claimed?.toString();
  const isSportsbookOnly: boolean = useMemo(
    () =>
      userBonus?.bonus?.sports &&
      userBonus?.bonus?.events?.every(event => event?.name == 'Sports'),
    [userBonus?.bonus],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <div
      className={styles.container}
      style={{
        //@ts-ignore
        '--data-claim-reward-modal-reward-color': userBonus?.bonus?.type
          ? Color(
              getBonusTypeColor(userBonus?.bonus?.type?.id as BonusTypeType),
            )
              .darken(0.5)
              .alpha(0.4)
              .toString()
          : '',
      }}
    >
      <div className={styles.container__form}>
        <BonusClaimModalContentHeader bonus={userBonus} isLoading={isLoading} />

        {isActiveBonus ? (
          <UserBonusCardCheckpointsRenderer
            curretCheckpointIndex={curretCheckpointIndex}
            isLoading={isLoading}
            userBonus={userBonus}
          />
        ) : (
          <UserBonusModalCoinTable
            isLoading={isLoading}
            userBonus={userBonus}
          />
        )}

        {userBonus?.bonus?.sports && <SportsCard userBonus={userBonus} />}

        {!isSportsbookOnly && (
          <div className={styles.container__form__text__wrapper}>
            <div className={styles.container__form__text}>
              {t('games_bonus_label')}
            </div>

            <UserBonusModalContentGames
              isLoading={isLoading}
              userBonus={userBonus}
            />
          </div>
        )}
      </div>
    </div>
  );
}
